import { render, staticRenderFns } from "./ModalDownloadCrm.vue?vue&type=template&id=befc32b2&scoped=true&"
import script from "./ModalDownloadCrm.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadCrm.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownloadCrm.vue?vue&type=style&index=0&id=befc32b2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc32b2",
  null
  
)

export default component.exports